/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2025, Zumper
 */

import { safeFilterActions } from '@zcode/utils'
import { geoReducer } from './reducer'
import { whitelist } from './whitelist'

export const geo = safeFilterActions(geoReducer, whitelist)
